(function () {
	'use strict';
	angular.module('app.core')
    .service('flexFilters', flexFilters);

	flexFilters.$inject = ['URLS'];
	function flexFilters(URLS) {
		var filters = {};
		var flexFields = globalConfig.customer.flexFields;
		_.each(flexFields, function (field, fieldName) {
			var filterDefinition = {
				id: fieldName,
				displayName: field.displayName,
				label: fieldName,
				authz: ['filters', 'flexFields'],
				updateOnFactory: true,
				sourceType: field.sourceType,
				type: field.filterType ? field.filterType.filterType : field.defaultFilterType.filterType
			};

			if (filterDefinition.type === 'multiselect') {
				filterDefinition.comparisonKey = fieldName;
				filterDefinition.url = String.format(URLS.getFlexFieldValues, globalConfig.factory.id);
				filterDefinition.unformattedUrl = URLS.getFlexFieldValues + fieldName + '&sourceTable=' + field.sourceTable;
				filterDefinition.useNotSelected = true;
			}

			filters[fieldName] = filterDefinition;
		});
		return filters;
	}
})();
